module.exports = __webpack_public_path__ + "img/intersect.e062be12.svg";